/**
 * Path helpers for the stories v2 surfaces. Isolated into a tiny
 * dependency-free module so UI components (e.g. `UserStoryAvatar`) can
 * import just the path builder without pulling in `lib/api/placements`
 * (which in turn imports axios and breaks legacy Jest ESM parsing).
 */

/**
 * Resolve the legacy SPA route for a user's story viewer. Mounts
 * `UserStoriesPage`, which in turn embeds the Next viewer in an iframe
 * overlay.
 */
export function buildUserStoriesPath(userId: number | string): string {
  return `/stories/${encodeURIComponent(String(userId))}`;
}
